import { CheckboxIcon, PencilIcon, TrashIcon } from "@aureskonnect/react-ui";
import classnames from "classnames";
import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";
import { FlexboxGrid } from "@components/Common/FlexboxGrid";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { store as storeGlobal } from "@components/VerticalLayout/store";
import { PostCity } from "../City/hooks";
import { formatZoneLivraisonData } from "./hooks";
import ErrorToast from "@components/Common/ErrorTost";
import { setOrders, store as shopStore } from "../../store";
import { useFetchGlobal } from "../../../../../../api/hooks";
import { useSnapshot } from "valtio";

export default function CustomIcons({
    e,
    setSelectedRows,
    setIsAddZone,
    selectedRowShops,
    setDataIsUpdated,
    isAddZone,
    zoneData,
}: any) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();

    const [isAlertModalOpened, setIsAlertModalOpened] = React.useState<boolean>(
        false
    );
    const { franchiseID } = useSnapshot(storeGlobal);

    function alertToggle() {
        setIsAlertModalOpened(!isAlertModalOpened);
    }

    async function deleteVille() {
        const localStZoneLivraison: any = formatZoneLivraisonData(
            zoneData.data
        );
        const arrayZone = localStZoneLivraison.filter((element: any) => {
            return !(
                e.selectedRow[t("remote Debut")] === element["DebutDistance"] &&
                e.selectedRow[t("end Distance")] === element["FinDistance"]
            );
        });

        const data = {
            shopId: selectedRowShops[0].shopId,
            franchiseID: franchiseID,
            key: "stZoneLivraison",
            data: arrayZone,
        };

        try {
            const responseData: any = await PostCity(data, fetchGlobal);
            if (responseData.error) {
                throw new Error("API returned an error");
            }

            const updatedDataPrice = {
                ...(shopStore.orders.dataPrice || {}),
                stZoneLivraison: data.data,
            };

            setOrders({ dataPrice: updatedDataPrice });
            toast.success(`${t("Deletion completed successfully")!}`, {
                position: toast.POSITION.TOP_CENTER,
                theme: "colored",
                icon: <CheckboxIcon height={25} width={25} fill="white" />,
            });

            setIsAlertModalOpened(false);
            setDataIsUpdated(true);
        } catch (error) {
            ErrorToast(`${t("There's an error")!}`);
        }
    }

    return (
        <React.Fragment>
            <div className="d-flex justify-content-between mt-2">
                <Tooltip title={t("Edit")}>
                    <IconButton>
                        <PencilIcon
                            onClick={() => {
                                setSelectedRows([e.selectedRow]);
                                setIsAddZone(true);
                            }}
                            height={25}
                            width={25}
                            style={{ cursor: "pointer" }}
                            className={`${classnames("pointer__clz", {})}`}
                        />
                    </IconButton>
                </Tooltip>

                <Tooltip title={t("Delete")}>
                    <IconButton>
                        <TrashIcon
                            onClick={() => {
                                setSelectedRows([e.selectedRow]);
                                setIsAlertModalOpened(true);
                            }}
                            height={25}
                            width={25}
                            fill="red"
                            style={{ cursor: "pointer" }}
                            className={`${classnames("pointer__clz", {})}`}
                        />
                    </IconButton>
                </Tooltip>
                <div />
            </div>
            <Modal
                isOpen={isAlertModalOpened}
                toggle={alertToggle}
                backdrop={false}
                fade={false}
                centered
            >
                <ModalHeader toggle={alertToggle}>
                    <span
                        style={{
                            textAlign: "left",
                            font: " normal normal 600 25px Segoe UI",
                            color: "#000000",
                        }}
                    >
                        {t("Alert")}
                    </span>
                </ModalHeader>
                <ModalBody
                    className="d-flex flex-column"
                    style={{ gap: "10px" }}
                >
                    <div
                        style={{
                            font: " normal normal 600 16px/20px Segoe UI",
                            textAlign: "left",
                            color: "#2B2828",
                            padding: "14px",
                        }}
                    >
                        {t(
                            "Do you want to confirm the deletion of the selected area?"
                        )}
                    </div>
                    <FlexboxGrid
                        className="pt-4 justify-content-end"
                        gap="10px"
                    ></FlexboxGrid>
                </ModalBody>
                <ModalFooter className="border-top-0">
                    <CustomSecondaryColorButton
                        outline
                        variant="light"
                        onClick={() => {
                            setIsAlertModalOpened(false);
                        }}
                        rounded
                    >
                        {t("Cancel")}
                    </CustomSecondaryColorButton>
                    <CustomMainColorButton
                        rounded
                        className="mr-2"
                        variant="primary"
                        onClick={deleteVille}
                    >
                        {t("Validate")}
                    </CustomMainColorButton>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}
